function mediumZoom(options) {
  let m;
  return {
    viewerEffect({ markdownBody }) {
      const imgs = [...markdownBody.querySelectorAll("img")].filter((e) => {
        var _a, _b;
        return ((_b = (_a = options == null ? void 0 : options.filter) == null ? void 0 : _a.call(options, e)) != null ? _b : true) && !e.closest("a");
      });
      if (imgs.length === 0)
        return;
      (async () => {
        if (!m) {
          m = await import("medium-zoom");
        }
        m.default(imgs, options);
      })();
    }
  };
}
export {
  mediumZoom as default
};
